import { DocumentValueCodes } from '@/enums/documentValueCodes.enum';

import { employmentPeriodEditorConfig } from './employmentPeriodEditorConfig';
import { DocumentValueEditorConfig, DocumentValueInput, DocumentValueMap } from './types';

// Rejestr kodów wartości dokumentu z dedykowanym komponentem i logiką obsługi.
const registry: Record<string, DocumentValueEditorConfig> = {
  [DocumentValueCodes.OW004_ART174_DEDUCTIONS]: employmentPeriodEditorConfig
};

// Normalizuje kod z formularza tak, aby wyszukiwanie w rejestrze było odporne na spacje.
function normalizeCode(code: unknown): string | null {
  if (typeof code !== 'string') {
    return null;
  }

  const normalizedCode = code.trim();
  return normalizedCode || null;
}

export function getDocumentValueEditorConfig(code: unknown): DocumentValueEditorConfig | undefined {
  const normalizedCode = normalizeCode(code);
  return normalizedCode ? registry[normalizedCode] : undefined;
}

// Przygotowuje wartość do modelu formularza na podstawie konfiguracji dla danego kodu.
export function normalizeDocumentValueByCode(code: unknown, value: DocumentValueInput = {}): DocumentValueInput {
  const config = getDocumentValueEditorConfig(code);
  return config && config.normalizeValue ? config.normalizeValue(value) : value;
}

// Tworzy domyślną wartość startową dla niestandardowego edytora.
export function createEmptyDocumentValueForCode(code: unknown, baseValue: DocumentValueMap = {}): DocumentValueMap {
  const config = getDocumentValueEditorConfig(code);
  return config && config.createEmptyValue ? config.createEmptyValue(baseValue) : baseValue;
}

// Pozwala konfiguracji przygotować schemat (np. dodać pierwszy pusty wiersz).
export function prepareDocumentValueSchemaByCode(code: unknown, schema: unknown): void {
  const config = getDocumentValueEditorConfig(code);
  if (config && config.prepareSchema) {
    config.prepareSchema(schema);
  }
}

// Zwraca skrót wyświetlany na liście wartości dokumentu.
export function formatCustomDocumentValueSummary(code: unknown, value: DocumentValueInput): string | null {
  const config = getDocumentValueEditorConfig(code);
  return config && config.formatSummary ? config.formatSummary(value) : null;
}
